import { superGrids, SuperGridType } from '@/superGrids.ts';
import { useEffect } from 'react';
import { useForm } from '@/form/useForm.ts';

export const useReactOnSupergrid = (superGridKeys: SuperGridType[], callback: () => void) => {
  const { getFieldValue } = useForm();
  useEffect(() => {
    const donorId = getFieldValue('donorId') as string;

    const skipgrids = superGridKeys.map((key) => superGrids[key].grid.toUpperCase());
    if (donorId && skipgrids.includes(donorId!.toUpperCase())) {
      callback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
